import type { UtilityContext } from '@change-corgi/core/react/utilityContext';

import { NotFoundError } from 'src/shared/error';

import type { MovementDataQuery, MovementDataQueryVariables } from './api.graphql';
import { MovementData } from './api.graphql';

export type MovementPageData = {
	movement: NonNullable<MovementDataQuery['movement']>;
};

export async function getMovementPageData({ gql: { fetch } }: UtilityContext, slug: string): Promise<MovementPageData> {
	const { data } = await fetch<MovementDataQuery, MovementDataQueryVariables>({
		query: MovementData,
		variables: {
			slugOrId: slug,
		},
		rejectOnError: true,
	});

	if (!data.movement) {
		throw new NotFoundError();
	}

	return {
		movement: data.movement,
	};
}
